import { Box } from "@mui/material";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { PomPlatformLogo, BatteryPickupPlatformLogo } from "../../components/Primitives/Icons";
import { useAuthContext } from "../../providers/Auth/auth.provider";
import { AvailablePlatform } from "../../providers/Auth/platform.provider";
import { getPomShortcuts } from "../../utils/shortcuts";
import { PlatformContainer } from "../../components/dashboard/platform-container.component";
import { PlatformContainerTitle } from "../../components/dashboard/platform-container-title.component";
import config from "../../config/config";
import { isAdmin, isPom, isPomAgency, isPomAgencyMember, isPomMainContact } from "../../domain/user/user";

export const DashboardPage: React.VFC = () => {
  const { t } = useTranslation();
  const { internalUser } = useAuthContext();

  const isPomPlatformAvailable = useMemo(() => {
    return (
      isPom(internalUser) ||
      isPomAgency(internalUser) ||
      isPomAgencyMember(internalUser) ||
      isPomMainContact(internalUser)
    );
  }, [internalUser]);

  const userHasPomRole = useMemo(() => {
    return isAdmin(internalUser) || internalUser?.rolePom != null;
  }, [internalUser]);

  return (
    <Box sx={{ display: "flex", justifyContent: "center", paddingTop: 5 }}>
      <Box sx={{ width: "100%", maxWidth: 700 }}>
        {isPomPlatformAvailable && userHasPomRole && (
          <PlatformContainer
            title={t("dashboard.platform.pom")}
            Logo={PomPlatformLogo}
            platform={AvailablePlatform.Pom}
            shortcuts={getPomShortcuts(internalUser)}
          />
        )}
        {config.bcCfmBatteryPickupUrl && (
          <Box sx={{ mt: 2 }}>
            <PlatformContainerTitle
              handleSelection={() => window.open(config.bcCfmBatteryPickupUrl, "_blank")}
              Logo={BatteryPickupPlatformLogo}
              title={t("dashboard.platform.batteryPickup")}
              showExternalLinkIcon
            />
          </Box>
        )}
      </Box>
    </Box>
  );
};
